module.exports = __webpack_public_path__ + "img/TetantPriceIcon.d0a3a7a9.svg";